import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { BreadcrumbV2Object } from '@osmosis/shared/types/learn';
import { TrackBreadcrumbHandler } from '@osmosis/shared/types/learn';
import BreadcrumbsDropdownV2 from '../BreadcrumbsV2/BreadcrumbsDropdownV2';
import { useContentSize } from '@osmosis/nextjs-components/context/ContentSizeContext';

type Props = {
  breadcrumbsv2?: BreadcrumbV2Object[];
  sectionName: string;
  linkClassName?: string;
  justifyDropdown?: 'flex-start' | 'center' | 'flex-end';
  isShowAllBreadcrumbs?: boolean;
  onBreadCrumbItemClick?: TrackBreadcrumbHandler;
};

/**
 * Renders breadcrumbs and breadcrumbs dropdown.
 */
const Breadcrumbs = (props: Props) => {
  const {
    breadcrumbsv2 = [],
    sectionName,
    linkClassName = '',
    justifyDropdown,
    isShowAllBreadcrumbs = true,
    onBreadCrumbItemClick,
  } = props;
  const { formatMessage } = useIntl();

  const { md } = useContentSize();

  const dropdownTitleOverride = formatMessage({
    id: 'learn.breadcrumb.view_in_library',
    defaultMessage: 'View in library',
  });

  const showBreadcrumbsDropdown =
    isShowAllBreadcrumbs && breadcrumbsv2.length > 0 && md;

  return breadcrumbsv2.length ? (
    <section
      aria-label={formatMessage(
        {
          id: 'learn.breadcrumbs.section',
          defaultMessage: 'Breadcrumbs for "{sectionName}"',
        },
        { sectionName },
      )}
    >
      <Box>
        {showBreadcrumbsDropdown ? (
          <BreadcrumbsDropdownV2
            breadcrumb={breadcrumbsv2}
            justifyDropdown={justifyDropdown}
            onBreadCrumbItemClick={onBreadCrumbItemClick}
            linkClassName={linkClassName}
            dropdownButtonClassName="pl-0 pb-0 pt-0 [&>p]:!text-sm"
            dropdownTitleOverride={dropdownTitleOverride}
          />
        ) : null}
      </Box>
    </section>
  ) : null;
};

export default Breadcrumbs;
